
import React, { useState } from 'react';
import { Badge } from '@/components/ui/badge';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Plus, X, Users } from 'lucide-react';

interface RoommateFieldProps {
  roommates: Array<{id: string, name: string}>;
  onAdd: (name: string) => void;
  onRemove: (id: string) => void;
}

export const RoommateField: React.FC<RoommateFieldProps> = ({
  roommates,
  onAdd,
  onRemove
}) => {
  const [newRoommate, setNewRoommate] = useState('');

  const handleAddRoommate = () => {
    if (newRoommate.trim()) {
      onAdd(newRoommate);
      setNewRoommate('');
    }
  };

  // Ensure roommates is always an array for rendering
  const roommatesList = Array.isArray(roommates) ? roommates : [];

  return (
    <div className="space-y-2">
      <Label htmlFor="roommates">Roommates</Label>
      <div className="flex flex-wrap gap-2 mb-2">
        {roommatesList.map(roommate => (
          <Badge key={roommate.id} variant="secondary" className="flex items-center gap-1">
            {roommate.name}
            <Button
              variant="ghost"
              size="icon"
              onClick={() => onRemove(roommate.id)}
              className="h-4 w-4 p-0 hover:bg-transparent"
            >
              <X className="h-3 w-3" />
            </Button>
          </Badge>
        ))}
      </div>
      <div className="flex items-center gap-2">
        <div className="flex items-center space-x-2 flex-1">
          <Users className="h-4 w-4 text-muted-foreground" />
          <Input 
            id="roommates"
            value={newRoommate}
            onChange={(e) => setNewRoommate(e.target.value)}
            placeholder="Enter roommate name"
            className="flex-1"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleAddRoommate();
              }
            }}
          />
        </div>
        <Button 
          type="button" 
          variant="outline"
          size="icon"
          onClick={handleAddRoommate}
        >
          <Plus className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
